import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA4_ID;
const GSC = process.env.REACT_APP_GSC_VERIFICATION;

let initialized = false;

/**
 * Analytics — loads GA4 (gtag.js) only when REACT_APP_GA4_ID is set, and tracks
 * SPA page_view events on every route change. Also injects the optional Google
 * Search Console verification meta tag when REACT_APP_GSC_VERIFICATION is set.
 * No-ops gracefully when env vars are empty.
 */
export default function Analytics() {
  const { pathname, search } = useLocation();

  // one-time GA4 + GSC setup
  useEffect(() => {
    if (GSC && !document.head.querySelector('meta[name="google-site-verification"]')) {
      const m = document.createElement("meta");
      m.setAttribute("name", "google-site-verification");
      m.setAttribute("content", GSC);
      document.head.appendChild(m);
    }

    if (!GA_ID || GA_ID.startsWith("G-XXXX") || initialized) return;
    initialized = true;

    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    // We send page_view manually per route to support the SPA.
    gtag("config", GA_ID, { send_page_view: false });
  }, []);

  // page_view on route change
  useEffect(() => {
    if (!window.gtag || !GA_ID) return;
    window.gtag("event", "page_view", {
      page_path: pathname + search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [pathname, search]);

  return null;
}
